import Store from '../Store';

const MarketStallStatementStore = new Store('markets/statements');

MarketStallStatementStore.list?.sort((a, b) => (a.marketDate > b.marketDate) ? -1 : 1);

export {MarketStallStatementStore};